





















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { amountTop, getUserRanking, userShareExp } from "@/api/user/user";
import style from "@/my-theme/var.less";
import moment from "moment";
@Component
export default class Content extends Vue {
  private primary: string = style.primary;
  private month = 0;

  private monthList = [];
  private totalList = [];

  private list = [];

  private expList = [];

  private type = 1;
  private update;
  private userInfo = this.$store.state.userInfo;
  private selfRankings = {
    perMonth: null,
    perTotal: null,
  };
  private selfRanking = null;
  private doTime = 0;

  private created() {
    this.getUserRanking();
    this.getList();

    const date = new Date();
    this.month = date.getMonth() + 1;

    this.update =
      "更新于" +
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate();
  }

  private async getList() {
    const res = (await amountTop()) as any;
    this.monthList = res.month;
    this.totalList = res.total;

    this.list = this.monthList;

    const expRes = (await userShareExp()) as any;
    var result = expRes ? expRes : [];
    if (result.length % 3 == 1) {
      result.splice(result.length - 1, 0, result[result.length - 3]);
      result.splice(result.length - 1, 0, result[result.length - 3]);
    } else if (result.length % 3 == 2) {
      result.splice(result.length - 2, 0, result[result.length - 3]);
    }

    for (let item of result) {
      if (!item.head_img) {
        item.head_img =
          "https://homepage.cdn.sdshua.com//longmahomepage/lmlogo.png";
      }
      item.time = moment(item.time * 1000 || "").format("YYYY-MM-DD");
    }

    let index = 0;
    let newArray = [];
    while (index < result.length) {
      newArray.push(result.slice(index, (index += 3)));
    }
    this.expList = newArray;
    console.log(this.expList);
  }

  private handleClick(path: string) {
    window.open(path, "_blank");
  }

  private changeType(type) {
    this.type = type;
    if (type == 1) {
      this.list = this.monthList;
      this.selfRanking = this.selfRankings.perMonth;
    } else {
      this.list = this.totalList;
      this.selfRanking = this.selfRankings.perTotal;
    }
  }

  private async getUserRanking() {
    const res = (await getUserRanking()) as any;
    if (res) {
      res.perMonth &&
        (res.perMonth.list_rank = res.perMonth.list_rank || "99+");
      res.perTotal &&
        (res.perTotal.list_rank = res.perTotal.list_rank || "99+");
      this.selfRankings = res;
      this.selfRanking = this.selfRankings.perMonth;
      this.doTime = res.do_time;
    }
  }
}
